import {TResponse, TUUID} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequest} from '../../ws';
import {TListItem} from './types';
import {getRefundItem} from './mock';

import {
  ENDPOINT_MERCHANT_REFUND_CANCEL,
  ENDPOINT_MERCHANT_REFUND_UPDATE,
  ENDPOINT_MERCHANT_REFUND_DETAILS
} from '../../../constants/api';

// Cancel refund
export function apiV2RefundCancel(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_REFUND_CANCEL;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Edit refund
export function apiV2RefundEdit(params: {refund_id: TUUID, email: string, name: string}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_REFUND_UPDATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Get detailed info
export function apiV2GetRefundDetails(params: {id: TUUID}): Promise<TListItem> {
  const url = ENDPOINT_MERCHANT_REFUND_DETAILS;

  if (process.env.MOCK) {
    const response = getRefundItem();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}
